import React from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Field, getFormValues, reduxForm } from 'redux-form'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getSpecialApproval, getProjectByCompany } from 'ducks/goa'

import { 
  GRContainer,
  RowFields
} from 'routes/ProcurementSystem/GoodsServiceReceipt/styled'

const RequestInformation = props => {

  const { 
    valueForm,
    specialApprovalInfo,
    projects,
    specialApprovals,
    specialApprovalLoading
  } = props

  React.useEffect(()=>{
    if(Object.keys(specialApprovalInfo.data).length){
      props.change('specialApprovalName',specialApprovalInfo.data.name)
    }
  },[specialApprovalInfo.data])

  React.useEffect(()=>{
    props.getSpecialApproval(valueForm.projectId)
  },[valueForm&&valueForm.projectId])

  React.useEffect(()=>{
    if(valueForm.companyCode){
      props.getProjectByCompany(valueForm.companyCode)
    }
  },[valueForm&&valueForm.companyCode])

  const setMember = () => {
    if(valueForm&&valueForm.requesterUser){
      let user = props.members.find(x=>x.username.toLowerCase()==valueForm.requesterUser.toLowerCase())
      if(!user){
        let result = props.members.map((m,i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
        result.push({
          key: `${lower(valueForm.requesterUser)}`,
          value: lower(valueForm.requesterUser),
          text: valueForm.requesterName
        })
        return result
      }else{
        return props.members.map((m,i) => ({
          key: `${lower(m.username)}_${i}`,
          value: lower(m.username),
          text: `${m.firstnameEn} ${m.lastnameEn}`,
        }))
      }
    }else{
      return []
    }
  }

  return (
    <GRContainer>
      <StdCard title="Request Information">
        <RowFields>
          <Field
            name='title'
            label='Title (Request for)'
            type={type.text}
            component={FieldInput}
            editable={false}
            tooltip
          />
          <Field
            name='requesterUser'
            label='Requester'
            editable={false}
            component={FieldInput}
            allowAdditions={false}
            loading={props.members.loading}
            options={setMember()}
            type={type.select}
          />
        </RowFields>
        <RowFields>
          <Field
            name='documentNumber'
            label='Document No.'
            type={type.text}
            component={FieldInput}
            editable={false}
          />
          <Field
            name='documentDate'
            label='Document Date'
            type={type.date}
            component={FieldInput}
            editable={false}
          />
        </RowFields>
        <RowFields>
          {(valueForm&&valueForm.status==4)?
          <Field
            name="createdMatDocNo"
            label="Material Document No./GRN No."
            type={type.text}
            component={FieldInput}
            editable={false}
          />
          :
          <Field
            name="companyCode"
            label="Company"
            type={type.select}
            allowAdditions={false}
            options={props.companies.data}
            loading={props.companies.loading} 
            component={FieldInput}
            editable={false}
          />
          }
          <Field
            name='modifiedDate'
            label='Modified Date'
            type={type.date}
            component={FieldInput}
            editable={false}
            dateFormat='dd MMM yyyy HH:mm'
          />
        </RowFields>
        <RowFields>
          {(valueForm&&valueForm.status==4)?
          <Field
            name="companyCode"
            label="Company"
            type={type.select}
            allowAdditions={false}
            options={props.companies.data}
            loading={props.companies.loading} 
            component={FieldInput}
            editable={false}
          />
          :
          valueForm&&valueForm.projectId&&valueForm.status!=4?
          <Field
            name='projectId'
            label='Project Name'
            loading={props.projectLoading}
            options={projects.map((x,i)=>({key:i,value:x.id,text:x.projectName}))}
            type={type.select}
            component={FieldInput}
            className='halfRow'
            editable={false}
          />
          :
          <div style={{ marginRight:'0.9375rem',flex: '1' }}></div>
          }
          <Field
            name='submittedDate'
            label='Submitted Date'
            type={type.date}
            component={FieldInput}
            editable={false}
            dateFormat='dd MMM yyyy HH:mm'
          />
        </RowFields>
        <RowFields>
          {valueForm&&valueForm.specialApprovalId&&valueForm.status!=4&&
          <Field
            name='specialApprovalName'
            label='Special Approval'
            className='halfRow'
            type={type.text}
            component={FieldInput}
            editable={false}
          />}
        </RowFields>
        <RowFields>
          {valueForm&&valueForm.projectId&&valueForm.status==4&&
          <Field
            name='projectId'
            label='Project Name'
            loading={props.projectLoading}
            options={projects.map((x,i)=>({key:i,value:x.id,text:x.projectName}))}
            type={type.select}
            component={FieldInput}
            className='halfRow'
            editable={false}
          />}
        </RowFields>
        <RowFields>
          {valueForm&&valueForm.specialApprovalId&&valueForm.status==4&&
          <Field
            name='specialApprovalName'
            label='Special Approval'
            className='halfRow'
            type={type.text}
            component={FieldInput}
            editable={false}
          />}
        </RowFields>
      </StdCard>
    </GRContainer>
  )   

}

const mapStateToProps = (state) => {
  let valueForm = getFormValues('formGR')(state)
  return ({
    members:state.member.members,
    companies:state.options.companies,
    valueForm: valueForm,
    specialApprovalInfo:state.gr.specialApprovalInfo,
    specialApprovals:state.goa.specialApprovals,
    specialApprovalLoading:state.goa.specialApprovalLoading,
    projects: state.goa.projects[(valueForm&&valueForm.companyCode)||""]||[],
    projectLoading: state.goa.projectLoading
  })
}

const mapDispatchToProps = {
  getSpecialApproval,
  getProjectByCompany
}

const contForm = reduxForm({
  form: 'formGR',
  enableReinitialize: true,
})(RequestInformation)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
